// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/NewPhone/Content/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_ContactInfo_Phone_NewPhone_Content(
  $patient_id: uuid!
  $contact_method_association_id: uuid!
) {
  vaxiom_appointment_bookings(
    where: {
      appointment: { patient: { _id: { _eq: $patient_id } } }
      state: { _eq: "SCHEDULED" }
      start_time: { _gt: "now()" }
    }
    order_by: { start_time: desc_nulls_last }
    limit: 1
  ) {
    id
  }

  vaxiom_communication_preferences(
    where: {
      contact_method_association: {
        _id: { _eq: $contact_method_association_id }
      }
    }
    limit: 1
  ) {
    id
  }
}

`